import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../context/SettingsContext';

const DynamicTitle = () => {
    const { settings } = useSettings();
    const location = useLocation();
    const businessName = settings?.business_name || 'BGRemove';

    useEffect(() => {
        // Map routes to page titles
        const pageTitles = {
            '/': `${businessName} - AI Background Removal`,
            '/login': `Login - ${businessName}`,
            '/register': `Sign Up - ${businessName}`,
            '/dashboard': `Dashboard - ${businessName}`,
            '/pricing': `Pricing - ${businessName}`,
            '/account': `Account Settings - ${businessName}`,
            '/contact': `Contact Us - ${businessName}`,
            '/terms': `Terms of Service - ${businessName}`,
            '/privacy': `Privacy Policy - ${businessName}`,
            '/disclaimer': `Disclaimer - ${businessName}`,
            '/forgot-password': `Reset Password - ${businessName}`,
            '/subscription/success': `Payment Successful - ${businessName}`,
            '/admin/login': `Admin Login - ${businessName}`,
            '/admin/dashboard': `Admin Dashboard - ${businessName}`,
        };

        // Get the title for the current route or use default
        const title = pageTitles[location.pathname] || `${businessName} - AI Background Removal`;

        // Update document title
        document.title = title;
    }, [location.pathname, businessName]);

    return null; // This component doesn't render anything
};

export default DynamicTitle;
